import {queryOptions} from '@tanstack/react-query';
import {unwrap} from 'framework';
import type {WorkoutsDependencies} from '../dependencies';
import type {WorkoutId} from '../domain/workout-id.value-object';
import {keys} from './keys';

export type GetWorkoutQueryDependencies = Pick<WorkoutsDependencies, 'controllers'>;

export const getWorkoutQuery = (
  {controllers}: GetWorkoutQueryDependencies,
  workoutId: WorkoutId,
) =>
  queryOptions({
    queryKey: keys.detail(workoutId),
    queryFn: () => controllers.workoutController.getById(workoutId).then(unwrap),
  });
